 <div class="p-grid">
   <div class="p-col-10 p-d-flex p-jc-between p-flex-wrap m-auto">
    <p-card class="p-m-5 p-d-flex"  [header]="noticia.titulo" styleClass="p-card-shadow" [style]="{width: '360px'}" *ngFor="let noticia of noticias">
      <p-header>
        <img  class="img-noticia" *ngIf="vectorImagenes[noticia.id]" [src]="vectorImagenes[noticia.id]" [alt]="noticia.imagen.nombre" />
        <img  class="img-noticia" *ngIf="!vectorImagenes[noticia.id]" [src]="imgDefault" [alt]="noticia.imagen.nombre" />
      </p-header>
        <span *ngIf="noticia.destacada" class="badge badge-success"><b>{{'NOTICIA.DESTACADA' | translate}}</b></span>
        <div [innerHtml]="noticia.body | slice:0:200 | formatPersonalText: 'resumenNoticia'"></div>
      <p-footer>
        <button pButton pRipple [label]="'NOTICIAS.VER' | translate" (click)="verNoticia(noticia.id)"></button>
    </p-footer>
  </p-card>
   </div>
 </div>




 <!--<p-dataView #dv [value]="noticias" [paginator]="true" [rows]="9" filterBy="name" [sortField]="sortField" [sortOrder]="sortOrder" layout="grid">
        <ng-template let-noticia pTemplate="gridItem">
            <div class="p-xl-4 p-lg-6 p-md-6 p-sm-12">
                <p-card class="p-grid noticiaStyle">
                    <div class="p-col-12 destacada">
                        <span *ngIf="noticia.destacada"><b>{{'NOTICIA.DESTACADA' | translate}}</b></span>
                    </div>
                    <div class="p-col-12 center">
                        <h3>{{noticia.titulo}}</h3>
                    </div>
                    <div class="p-col-12 center">
                        <img class="imgNoticia" [src]="vectorImagenes[noticia.id]" [alt]="noticia.imagen.nombre" />
                    </div>
                    <div class="p-col-12">
                      <iframe class="frame-noticias" [srcdoc]="noticia.body | slice:0:200 | formatPersonalText: 'resumenNoticia'">
                      </iframe>
                    </div>
                    <div class="p-col-12 center">
                        <button pButton pRipple [label]="'NOTICIAS.VER' | translate" (click)="verNoticia(noticia.id)"></button>
                    </div>
                </p-card>
            </div>
        </ng-template>
    </p-dataView>-->
